import PropTypes from 'prop-types';
import React from 'react';

import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';

import 'commons-vehicle/Vehicle/components/CallToAction/ExtraCta/ExtraCTAV25.scss';

const replaceParams = (url, params) => {
    return url.replace(/{(.*?)}/g, (match, p1) => {
        return params[p1] || match;
    });
};

const ExtraCTAV25 = ({ quote, buttonClass, ctaLabel, ctaLink }) => {
    if (!ctaLink || !ctaLabel) return null;

    const { make, model, year, vehicleId, stockNo, vin } = quote.vehicle || {};

    const vehicleParams = {
        vin,
        make: make.slug,
        model: model.slug,
        year,
        stockNo,
        vehicleId,
    };

    const formattedLink = replaceParams(ctaLink, vehicleParams);

    const target = ctaLink?.startsWith('http') ? '_blank' : '_self';

    const currentClass = [buttonClass, 'vehicle-cta-btn'];

    return (
        <a href={formattedLink} className={currentClass.join(' ')} target={target}>
            <span>{ctaLabel}</span>
        </a>
    );
};

ExtraCTAV25.defaultProps = {
    ctaLabel: '',
    ctaLink: '',
    buttonClass: 'sr-button-2',
};

ExtraCTAV25.propTypes = {
    ctaLabel: PropTypes.string,
    buttonClass: PropTypes.string,
    ctaLink: PropTypes.string,
    quote: PropTypes.instanceOf(QuoteModelV25).isRequired,
};

ExtraCTAV25.displayName = 'ExtraCTAV25';

export default ExtraCTAV25;
